import React, { useState, useCallback } from 'react'
import Welcome from './Welcome'
import { get, lowerFirst } from 'lodash'
import { RequirementsModal } from 'civic-champs-shared/question-sets/components'
import { useShowPrompt } from 'civic-champs-shared/core/modal/hooks'
import { useSelfApply } from '../../hooks'
import { createMarkup } from 'civic-champs-shared/core/utils/helpers'

import { invitationTypeToActionLookup } from 'civic-champs-shared/question-sets/types'
import { Button } from '@material-ui/core'

function DefaultStartingInstructions({ organization, group, membershipName }) {
  return (
    <>
      Please click the button below to continue your application. You must agree to all of the following waivers and
      answer all required questions (denoted with an asterisk) to become a {group.name} {lowerFirst(membershipName)} for{' '}
      {organization.name}.
      <br />
      <br />
      Thank you!
    </>
  )
}

function DefaultCompletionInstructions({ organization, group }) {
  return (
    <>
      Thank you for completing your application for {organization.name}'s Group: {group.name}. If you have any questions
      about your application, contact your volunteer coordinator.
    </>
  )
}

export default function AcceptRequirements({ person, group, orgSlugName, organization }) {
  const [inProgress, setInProgress] = useState(true)
  const fulfillRequirementsPrompt = useShowPrompt(RequirementsModal)
  const [selfApply] = useSelfApply()

  const membershipName = group.closed ? 'Applicant' : 'Member'

  const handleRequirements = useCallback(async () => {
    try {
      const done = await fulfillRequirementsPrompt({
        person,
        filters: {
          associatedEntity: {
            organizationId: organization.id,
            groupId: group.id,
          },
          personId: person.id,
          action: get(invitationTypeToActionLookup, 'custom_group'),
          freshAnswerSet: false,
          excludeCompletedAnswerSets: true,
          excludeCredentials: false,
        },
        isAdmin: false,
        continueEvenIfError: false,
        organizationId: organization.id,
      })
      if (done) {
        await selfApply({ groupId: group.id, orgSlugName, userId: person.id })
        setInProgress(false)
      }
    } catch (error) {
      console.error(error)
    }
  }, [fulfillRequirementsPrompt, group.id, orgSlugName, organization.id, person, selfApply])

  if (inProgress) {
    return (
      <div className="invite-header">
        {group.applicationStartInstructions ? (
          <div
            style={{ textAlign: 'center' }}
            dangerouslySetInnerHTML={createMarkup(group.applicationStartInstructions)}
          />
        ) : (
          <p style={{ textAlign: 'center' }}>
            <DefaultStartingInstructions organization={organization} group={group} membershipName={membershipName} />
          </p>
        )}
        <Button className="submit button" onClick={handleRequirements}>
          Continue with Application
        </Button>
      </div>
    )
  }

  return (
    <Welcome organization={organization}>
      <div className="invite-header">
        {group.applicationCompletionInstructions ? (
          <div
            style={{ textAlign: 'center' }}
            dangerouslySetInnerHTML={createMarkup(group.applicationCompletionInstructions)}
          />
        ) : (
          <p style={{ textAlign: 'center' }}>
            <DefaultCompletionInstructions organization={organization} group={group} />
          </p>
        )}
      </div>
    </Welcome>
  )
}
